import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFrance = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80027",
			d: "M512 256A256 256 0 0 0 345 16v480a256 256 0 0 0 167-240z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0052b4",
			d: "M0 256a256 256 0 0 0 167 240V16A256 256 0 0 0 0 256z"
		})
	]
});
export default SvgFrance;
